import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { withRouter } from 'react-router-dom';
import SocialIcons from './SocialIcons';
import { getBrandId } from '../../config';
import { transformToLegacyFormat } from '../../utils/affiliateTransform';

const socialProvidersQuery = gql`
  query SocialIcons($brandId: String!) {
    options {
      socialProviders(brandId: $brandId) {
        alias
        name
      }
    }
  }
`;

const socialAccountsQuery = gql`
  query SocialAccounts($playerUUID: String!) {
    playerSocialAccounts(playerUUID: $playerUUID) {
      data {
        id
        provider
      }
    }
  }
`;

export default compose(
  withRouter,
  connect(({ auth: { logged, uuid }, affiliate, promo }) => ({
    logged,
    uuid,
    affiliate: transformToLegacyFormat(affiliate, promo),
  })),
  graphql(socialProvidersQuery, {
    name: 'socialProviders',
    options: () => ({
      variables: {
        brandId: getBrandId(),
      },
    }),
  }),
  graphql(socialAccountsQuery, {
    options: ({ uuid }) => ({
      variables: {
        playerUUID: uuid,
      },
    }),
    skip: ({ logged }) => !logged,
    name: 'socialAccounts',
  })
)(SocialIcons);
